import config from '@/configs'
import moment from "moment"
import { sendErrorNotice, sendDialogNotice } from '@/commons/utils';
import { currency } from "@/commons/currency";
import { display_date } from "@/commons/formater";
export function request_header(token) {
  return {
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "accept": "application/json",
  };
}

export function request_payload(param) {
  let query = '';
  let q_params = [];
  if(param && (param.pagination || param.qObject || param.filter || param.quickFilter)) {
    const page = param.pagination && param.pagination.page ? param.pagination.page : 1
    const rowsPerPage = param.pagination && param.pagination.itemsPerPage ? param.pagination.itemsPerPage : 1000000
    const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
    const descending = param.pagination ? param.pagination.sortDesc[0] : 1
    const qObject = param.qObject ? Buffer.from(JSON.stringify({ qObject: param.qObject })).toString("base64") : '';
    const filter = param.filter && param.filter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.filter })).toString("base64") : '';
    const quickFilter = param.quickFilter && param.quickFilter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.quickFilter })).toString("base64") : '';
    q_params.push(`filter=${encodeURIComponent(filter)}&qObject=${encodeURIComponent(qObject)}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}&q=${encodeURIComponent(quickFilter)}`)
  }
  
  if(param) {
    var fields = []
    Object.keys(param).forEach((key) => {
      if(!['pagination', 'qObject', 'filter', 'quickFilter'].includes(key)) {
        fields.push(`${key}=${param[key] == null ? '' : param[key]}`)
      }
    });
    q_params.push(`${fields.join('&')}`);
  }
  query = `?${q_params.join('&')}`;
  return query;
}

export function request_list(endpoint, cb, $http, param, token) {
  const req = {
    headers: request_header(token)
  };
  
  const query = request_payload(param);

  $http.get(`${config.API}/admin/api/${endpoint}/${query}`, req).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
    }
  });
}

export function export_list(endpoint, cb, $http, param, token, func) {
  const req = {
    headers: request_header(token),
    responseType: 'blob'
  };
  func = func ? func : 'export'
  const query = request_payload(param)

  $http.get(`${config.API}/admin/api/${endpoint}/${func}/${query}`, req).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function import_list(endpoint, cb, $http, param, token, func) {
  const header = {
    headers: request_header(token),
  };
  header.headers['Content-Type'] = 'multipart/form-data';
  func = func ? func : 'import'

  $http.post(`${config.API}/admin/api/${endpoint}/${func}/`, param, header).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function import_list_v2(endpoint, cb, $http, param, token, func) {
  const header = {
    headers: request_header(token),
    responseType: 'blob'
  };
  header.headers['Content-Type'] = 'multipart/form-data';
  func = func ? func : 'import'

  $http.post(`${config.API}/admin/api/${endpoint}/${func}/`, param, header).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function request_detail(endpoint, cb, $http, id, token, param) {
  const header = {
    headers: request_header(token)
  };
  let query = '';
  if(param) {
    if(param.pagination) {
      const page = param.pagination ? param.pagination.page : 1
      const rowsPerPage = param.pagination ? param.pagination.itemsPerPage : 1000000
      const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
      const descending = param.pagination ? param.pagination.sortDesc[0] : 1
      query = `?page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}`;
      delete param.pagination;
    }
    var fields = []
    Object.keys(param).forEach((key) => fields.push(`${key}=${param[key]}`));
    query = query == '' ? `?${fields.join('&')}` : `${query}&${fields.join('&')}`;
  }
  $http.get(`${config.API}/admin/api/${endpoint}/${id}${query}`, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
    }
  });
}

export function update_detail(endpoint, cb, $http, param, pId, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  let path = pId == 0 ? `${config.API}/admin/api/${endpoint}/` : `${config.API}/admin/api/${endpoint}/${pId}`;
  $http.post(path, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
      setTimeout(() => cb(err), 100);
    }
  });
}

export function remove_detail(endpoint, cb, $http, id, token) {
  const header = {
    headers: request_header(token)
  };
  $http.delete(`${config.API}/admin/api/${endpoint}/${id}`, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
    }
  });
}

export function create_detail(endpoint, cb, $http, param, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  delete req['ID'];
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  $http.put(`${config.API}/admin/api/${endpoint}/`, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendDialogNotice(err.data.reason);
      setTimeout(() => cb(err), 100);
    }
  });
}

export function upload_file(endpoint, cb, $http, param, token, func) {
  const header = {
    headers: request_header(token)
  };
  header.headers['Content-Type'] = 'multipart/form-data';
  func = func ? func : 'import'

  $http.post(`${config.API}/admin/api/${endpoint}/${func}/`, param, header).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function update_multiple(endpoint, cb, $http, token, param) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);

  $http.post(`${config.API}/admin/api/${endpoint}/`, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  });
}

export function comment_type(value) {
  const cmtType = config.COMMENT_TYPE.find(obj => obj.id === value);
  return cmtType ? cmtType.name : '';
}

export function comment_type_color(value) {
  const cmtType = config.COMMENT_TYPE.find(obj => obj.id === value);
  return cmtType ? cmtType.color : '#e6c87f';
}

export function comment_avatar(value) {
  if (value !== null) {
    return '/android-icon-96x96.png?v=23010301';
  }
  return '/static/avatar/no_avatar.png';
}

export function comment_color(value) {
  if (value) {
    return '#ff0000';
  }
  return '#0000ff';
}

export function payment_type(value) {
  switch (value) {
    case 2:
    case 3:
      return "Đặt cọc";
    case 12:
      return "Hoàn tiền"
    default:
      return "Thanh toán";
  }
}

export function payment_type_color(value) {
  switch (value) {
    case 2:
      return "#e6c87f";
    case 3:
      return "#ffff00";
    case 12:
      return "#ff0000"
    default:
      return "#0000ff";
  }
}

export function complain_type(value) {
  switch (value) {
    case 1:
      return "Chờ xử lý";
    case 2:
      return "Đang xử lý";
    case 3:
      return "Đã xử lý"
    default:
      return "Đã hủy";
  }
}

export function complain_type_color(value) {
  switch (value) {
    case 1:
      return "#ff0000";
    case 2:
      return "#797960";
    case 3:
      return "#0000ff"
    default:
      return "#e6c87f";
  }
}

export function trade_type(value) {
  const cmtType = config.TRADE_TYPE.find(obj => obj.value === value);
  return cmtType ? cmtType.name : '';
}

export function print_transaction(weight, weight_v2, length, width, height, transactionCode, customerName, orderId, numberOfCode) {
  var mywindow = window.open("", "PRINT");

  mywindow.document.write("<html><head><title></title>");
  mywindow.document.write(
    "<style>.row {display: flex;}.flex {flex: 1 1 auto;}.flex.lg6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}"
  );
  mywindow.document.write(
    ".flex.lg12 {flex-basis: 100%;flex-grow: 0;max-width: 100%;}.title {font-size: 24px; font-weight: bold; text-align: center; margin: 5px 0 3px 0 !important;}"
  );
  mywindow.document.write(
    ".sub-title {font-size: 16px; font-weight: bold; margin: 0 0 8px 0 !important;}.l-text {text-align: left;}.r-text {text-align: right;}.note-text {font-size: 14px; font-weight: bold; font-style: italic; text-align: center;}"
  );
  mywindow.document.write(
    "</style></head><body style='height:8cm; width:9cm; margin-left: 5px; margin-right:5px;'>"
  );
  mywindow.document.write("<div class='layout wrap'>");
  mywindow.document.write(
    `<div class='flex lg12'><p class='title'>${customerName}</p></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><hr class='v-divider theme--light'></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='title'>${orderId}</p></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Số kiện</p></div><div class='flex lg6'><p class='sub-title r-text'>${numberOfCode}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Khối lượng</p></div><div class='flex lg6'><p class='sub-title r-text'>${weight > weight_v2 ? weight : weight_v2} kg</p></div></div>`
  );
  if(weight_v2 > weight) {
    mywindow.document.write(
      `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Kích thước (cm)</p></div><div class='flex lg6'><p class='sub-title r-text'>${length} x ${width} x ${height}</p></div></div>`
    );
  }
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Mã vận đơn</p></div><div class='flex lg6'><p class='sub-title r-text'>${transactionCode}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Ngày tạo</p></div><div class='flex lg6'><p class='sub-title r-text'>${moment(
      new Date()
    ).format("DD-MM-YYYY")}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>Lưu ý</p></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>Qúy khách vui lòng giữ lại mã vận đơn Trung Quốc để sử dụng trong trường hợp khiếu nại với shop.</p></div>`
  );
  mywindow.document.write(`<hr class='v-divider theme--light'>`);
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>${config.SYSTEM_CONFIG.domain}</p></div>`
  );
  mywindow.document.write("</div>");
  mywindow.document.write("</body></html>");

  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  // mywindow.close();
  return true;
}

export function print_transaction_v2(item) {
  var mywindow = window.open("", "PRINT");
  let barcode_width = item.TransactionCode && item.TransactionCode.length <= 17 ? 1.86 : 1.48
  mywindow.document.write(`<html>
  <head>
      <title></title>
      <script src="https://cdn.jsdelivr.net/jsbarcode/3.5.1/JsBarcode.all.min.js"></script>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 9px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 9px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 9px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #dddddd; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; } @media print { @page { size: auto; margin: 2mm 2mm 2mm 2mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } }
      </style>
  </head>
  
  <body style='width:100mm'>
      <div class='layout wrap'>
          <table>
              <tr>
                  <td class='m-text' colspan='4'><svg id="code128"></svg></td>
                  <td class='sub-title m-text'>Id Custom: ${item.UID}<br/>Order Id: ${(item.PackageType == 1 ? 'KG' : 'MD') + item.OrderID}</td>
              </tr>
              <tr>
                  <td class='body-text m-text'>FROM</td>
                  <td class='body-text' colspan='4'>Name : Guangzhou Ronghe Purchasing Agent Co. LTD
                      <br/>Mobile: +8615677000469
                      <br/>Add: Building 2, No. 181, Wanggang Xiling Road, Jiahe Street, Baiyun District, Guangzhou City, Guangdong Province, China</td>
              </tr>
              <tr>
                  <td class='body-text m-text' rowspan='3'>TO</td>
                  <td class='body-text'>Name</td>
                  <td class='body-text' colspan='3'>${item.FullName}</td>
              </tr>
              <tr>
                  <td class='body-text'>Mobile</td>
                  <td class='body-text' colspan='3'>${item.FakePhone}</td>
              </tr>
              <tr>
                  <td class='body-text'>Add</td>
                  <td class='body-text' colspan='3'>${item.Address}</td>
              </tr>
              <tr>
                  <td class='sub-title' colspan='5'>Shipment Detail</td>
              </tr>
              <tr>
                  <td class='body-text m-text' colspan='2'>Service</td>
                  <td class='body-text' colspan='3'>E</td>
              </tr>
              <tr>
                  <td class='body-text m-text' colspan='2'>Product Quantity<br/>(Số lượng SP)</td>
                  <td class='body-text m-text'>Actual weight<br/>(Trọng lượng thực tế kg)</td>
                  <td class='body-text m-text'>Volume<br/>(Thể tich m3)</td>
                  <td class='body-text m-text'>Chargeable weight<br/>(Khối lượng tính phí)</td>
              </tr>
              <tr>
                  <td class='sub-title m-text' colspan='2'>${ currency(item.ProductNumber)}</td>
                  <td class='sub-title m-text'>${ currency(item.Weight, '', 2)}</td>
                  <td class='sub-title m-text'>${ currency(item.Volume, '', 3)}</td>
                  <td class='sub-title m-text'>${ currency(item.ChargeableWeight, '', 2)}</td>
              </tr>
              <tr>
                  <td class='sub-title' colspan='5'>Product Detail</td>
              </tr>
              <tr>
                  <td class='body-text m-text' colspan='4'>Name</td>
                  <td class='body-text m-text'>Product Detail</td>
              </tr>
              <tr>
                  <td class='body-text m-text' colspan='4'>${item.ProductName ? item.ProductName : ''}</td>
                  <td class='body-text m-text'></td>
              </tr>
              <tr>
                  <td class='body-text m-text' colspan='2'>Payment COD: <b>${ currency(item.ProductAmountVND)}VNĐ</b></td>
                  <td class='body-text m-text' colspan='3'>Receiver's signature<br/>(Confirm intact goods)</td>
              </tr>
          </table>
      </div>
      <script>
        JsBarcode("#code128", "${item.TransactionCode}", {format: "code128", fontSize: 16, height: 66, width: ${barcode_width}, textMargin: 2});
      </script>
  </body>
  </html>`);
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  // mywindow.print();
  // mywindow.close();
  return true;
}

export function print_bigpackage(bigpackage_code, created_date, export_date, numberOfPackage, weight, volume, quantity) {
  let frame_printing = `<html>
  <head>
      <title></title>
      <script src="/static/js/JsBarcode.all.min.js"></script>
      <script src="/static/js/qrcode.min.js"></script>
      <style>
          .row { display: flex; } 
          .flex { flex: 1 1 auto; } 
          .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } 
          .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } 
          .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } 
          .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } 
          .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } 
          .title { font-size: 16px; font-weight: bold; text-align: center; } 
          .sub-title { font-size: 10px; font-weight: bold; } 
          .l-text { text-align: left; } 
          .r-text { text-align: right; } 
          .m-text { text-align: center; } 
          .note-text { font-size: 10px; font-weight: bold; font-style: italic; text-align: center; } 
          .body-text { font-size: 10px; } 
          .code-text { font-size: 48px; font-weight: bold; max-width: 75mm; overflow: hidden; white-space: nowrap; } 
          table { border-collapse: collapse; width: 100%; } 
          td, th { border: 1px solid #dddddd; text-align: left; padding: 1px; } 
          hr { border: 0.5px solid #dddddd; } 
          tr, td, th { page-break-inside: avoid !important; } 
          @media print { 
              @page { size: auto; margin: 2mm 2mm 2mm 2mm; } 
              html { background-color: #FFFFFF; margin: 0px; } 
              body { margin: 0mm 0mm 0mm 0mm; } 
          }
      </style>
  </head>
  
  <body style='width:75mm'>
      <div class='layout wrap'>
          <table>
              <tr>
                <td class='m-text' colspan='6'><div id="qrcode" style="display: flex; justify-content: center;"></div></td>                
              </tr>
              <tr>
                <td class='m-text' colspan='6'><svg id="code128"></svg></td>                
              </tr>
              <tr>
                  <td class='code-text m-text' colspan='6' id="bigpackage_code">${bigpackage_code}</td>     
              </tr>
              <tr>
                  <td class='body-text'>QUANTITY(PCS)</td>
                  <td class='body-text'>${currency(numberOfPackage)}</td>
                  <td class='body-text'>WEIGHT(KG)</td>
                  <td class='body-text'>${currency(weight,'',2)}</td>
                  <td class='body-text'>CUBE(CBM)</td>
                  <td class='body-text'>${currency(volume,'',3)}</td>
              </tr>
          </table>
      </div>
      <script>
          JsBarcode("#code128", "${bigpackage_code}", {format: "code128", fontSize: 18, height: 68, width: 1.86, textMargin: 2, displayValue: false});
          new QRCode(document.getElementById("qrcode"), {
            text: "${bigpackage_code}",
            width: 96,
            height: 96,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.H
          });

          // Sử dụng var thay vì const để tránh lỗi khai báo lại
          var codeElement = document.getElementById("bigpackage_code");
          var maxWidth = 75 * 3.78; // Chuyển 75mm thành pixel (1mm ≈ 3.78px ở 96dpi)
          var fontSize = 48; // Cỡ chữ tối đa ban đầu
          codeElement.style.fontSize = fontSize + "px";
          
          // Đo chiều rộng thực tế và giảm cỡ chữ nếu cần
          while (codeElement.scrollWidth > maxWidth && fontSize > 32) {
              fontSize -= 1;
              codeElement.style.fontSize = fontSize + "px";
          }
      </script>
  </body>
  </html>`;

  var doc = document.getElementById('print_frame').contentWindow.document;
  doc.open(); // Xóa nội dung cũ
  doc.write(frame_printing);
  doc.close();
  setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
}

export function print_export_receipt_order_v1(item, packages, render = false, payment = false, bigpackage = false) {
  let html_packages = ''
  packages = _.orderBy(packages, 'BigPackageID');
  let last_bigpackage_id = 0;
  let group_idx = 0;
  for (let i = 0; i < packages.length; i++) {
    const p = packages[i];
    if(last_bigpackage_id != p.BigPackageID && bigpackage) {
      group_idx = 0;
    }
    group_idx++;
    const _packages = _.filter(packages, (t) => {return t.BigPackageID == p.BigPackageID});
    html_packages = html_packages + `<tr>
                        <td class='body-text m-text'>${i+1}</td>
                        ${!bigpackage ? "<td class='body-text m-text'>" + p.PackageCode + "</td>" : '' }
                        ${group_idx == 1 && bigpackage ? "<td class='body-text m-text' rowspan='"+ _packages.length +"'>" + p.PackageCode + "</td>" : ''}
                        <td class='body-text'>${p.TransactionCode}</td>
                        <td class='body-text'>${p.Status == 5 ? 'Đã xuất' : 'Chưa xuất'}</td>
                        <td class='body-text m-text'>${p.PackageType == 1 ? 'KG' : 'MD'}${p.OrderID}</td>
                        <td class='body-text r-text'>${currency(p.NumberOfPack,'',0)}</td>
                        ${payment ? "<td class='body-text r-text'>" + currency(parseInt(p.FeeShip*p.ExchangeRate),'',0) + "</td>" : ""}
                        <td class='body-text r-text'>${currency(p.Weight,'',2)}</td>
                        <td class='body-text r-text'>${currency(p.Volume, '', 3)}</td>
                        ${payment ? "<td class='body-text r-text'>" + (p.PriceType != 3 ? currency(p.PriceType == 1 ? p.Weight : p.WeightByVolume,'',2) : '') + "</td>" : ""}
                        ${payment ? "<td class='body-text r-text'>" + (p.PriceType == 3 ? currency(p.Volume,'',3) : '') + "</td>" : ""}
                        ${payment ? "<td class='body-text r-text'>" + currency(p.FeeWeight,'',0) + "</td>" : ""}
                        ${payment ? "<td class='body-text r-text'>" + currency(p.FeeWeightAvg || p.TotalFeeWeight,'',0) + "</td>" : ""}
                        ${payment ? "<td class='body-text r-text'>" + currency(Math.max(p.FeeWeightAvg, p.TotalFeeWeight) + parseInt(p.FeeShip*p.ExchangeRate),'',0) + "</td>" : ""}
                        <td class='body-text m-text'></td>
                      </tr>`;
    if(group_idx == _packages.length && _packages.length < packages.length && bigpackage) {
      html_packages = html_packages + `<tr>
        <td class='sub-title m-text' colspan='5'></td>
        <td class='sub-title r-text'>${currency(_.sumBy(_packages, 'NumberOfPack'),'',0)}</td>
        ${payment ? "<td class='sub-title r-text'>" + currency(_.sumBy(_packages, (p) => {return parseInt(p.FeeShip * p.ExchangeRate);}),'',0) + "</td>" : ""}
        <td class='sub-title r-text'>${currency(_.sumBy(_packages, 'Weight'),'',2)}</td>
        <td class='sub-title r-text'>${currency(_.sumBy(_packages, 'Volume'),'',3)}</td>
        ${payment ? "<td class='sub-title r-text'>" + currency(_.sumBy(_packages, (p) => {return p.PriceType != 3 ? (p.PriceType == 1 ? p.Weight : p.WeightByVolume) : 0;}),'',2) + "</td>" : ""}
        ${payment ? "<td class='sub-title r-text'>" + currency(_.sumBy(_packages, (p) => {return p.PriceType == 3 ? p.Volume : 0;}),'',3) + "</td>" : ""}
        ${payment ? "<td class='sub-title r-text'></td>" : ""}
        ${payment ? "<td class='sub-title r-text'>" + currency(_.sumBy(_packages, (p) => {return p.FeeWeightAvg || p.TotalFeeWeight;}),'',0) + "</td>" : ""}
        ${payment ? "<td class='sub-title r-text'>" + currency(_.sumBy(_packages, (p) => {return p.FeeWeightAvg || p.TotalFeeWeight;}) + _.sumBy(_packages, (p) => {return parseInt(p.FeeShip * p.ExchangeRate);}),'',0) + "</td>" : ""}
        <td class='sub-title m-text'></td>
      </tr>`
    }
    last_bigpackage_id = p.BigPackageID;
  }

  let contact_info = `<tr><td class='no-boder sub-title'>Người nhận: DL${item.CustomerID} - ${item.CustomerName}</td></tr>
                      <tr><td class='no-boder sub-title'>Điện thoại: ${item.PhoneNumber}</td></tr>
                      <tr><td class='no-boder sub-title' colspan='2'>Người nhận hàng: ${item.Address}</td></tr>`
  let finance = ''
  let qrcode = ''
  let payment_note = ''
  if(payment) {
    if(item.OldPayLeft !== undefined && item.NewPayLeft !== undefined) {
      contact_info = `
        <tr>
          <td class='no-boder sub-title'>Người nhận: DL${item.CustomerID} - ${item.CustomerName}</td>
          <td class='no-boder sub-title'>Tổng nợ cũ: ${currency(item.OldPayLeft)}</td>
        </tr>
        <tr>
          <td class='no-boder sub-title'>Điện thoại: ${item.PhoneNumber}</td>
          <td class='no-boder sub-title'>Phí ship: ${currency(item.FeeOther)}</td>
        </tr>
        <tr>
          <td class='no-boder sub-title'>Địa chỉ: ${item.Address}</td>
          <td class='no-boder sub-title'>Tổng phát sinh: ${currency(item.NewPayLeft)}</td>
        </tr>
        <tr>
          <td class='no-boder sub-title'></td>
          <td class='no-boder sub-title'>Dư ví: ${currency(item.Wallet)}</td>
        </tr>
        <tr>
          <td class='no-boder sub-title'></td>
          <td class='no-boder sub-title'>Cần trả thêm: ${currency(item.Remain)}</td>
        </tr>
      `;
    }
    else {
      contact_info = `
        <tr>
          <td class='no-boder sub-title'></td>
          <td class='no-boder sub-title'>Phí ship: ${currency(item.FeeOther)}</td>
        </tr>
        <tr>
          <td class='no-boder sub-title'>Người nhận: DL${item.CustomerID} - ${item.CustomerName}</td>
          <td class='no-boder sub-title'>Tổng tiền chưa trả: ${currency(item.PayLeft)}</td>
        </tr>
        <tr>
        <td class='no-boder sub-title'>Điện thoại: ${item.PhoneNumber}</td>
        <td class='no-boder sub-title'>Dư ví: ${currency(item.Wallet)}</td>
        </tr>
        <tr>
          <td class='no-boder sub-title'>Địa chỉ: ${item.Address}</td>
          <td class='no-boder sub-title'>Cần trả thêm: ${currency(item.Remain)}</td>
        </tr>
      `;
    }
    qrcode = `<tr>
                  <td class='no-boder body-text m-text' colspan='${payment ? 12 : 8}'>Quý khách vui lòng scan một trong các tài khoản bên dưới để thanh toán nhanh nhất.</td>
              </tr>
              <tr>
                <td class='no-boder sub-title m-text' colspan='${payment ? 6 : 4}'><image src='https://vietqr.app/img?acc=0972582984&bank=MBBank&amount=${item.Remain}&des=DL${item.CustomerID}&holder=BUI+KHANH+LY&template=compact&showinfo=true' style='width: 240px'/></td>
                <td class='no-boder sub-title m-text' colspan='${payment ? 6 : 4}'><image src='https://vietqr.app/img?acc=1233568688&bank=ACB&amount=${item.Remain}&des=DL${item.CustomerID}&holder=BUI+KHANH+LY&template=compact&showinfo=true' style='width: 240px'/></td>
              </tr>`;
    payment_note = `<tr>
                      <td class='no-boder body-text' colspan='12'><i>*Nợ cũ: là tổng tiền các đơn hàng (không thuộc phiếu này) đã xuất nhưng chưa thanh toán.</i></td>
                    </tr> 
                    <tr>
                        <td class='no-boder body-text' colspan='12'><i>*Phát sinh: là tổng tiền các đơn hàng thuộc phiếu này (bao gồm tiền cân, tiền hàng chưa cọc và phí khác nếu có).</i></td>
                    </tr> `;
  }

  const print_content = `<html>
  <head>
      <title>Phiếu xuất kho</title>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 11px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 11px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 11px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 30px; padding: 5px} @media print { @page { size: auto; margin: 20mm 8mm 8mm 20mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } } .no-boder {border: 0px !important;} .quantity {width: 30px;} .width-volumn {width: 50px;}
      </style>
  </head>
  
  <body style='width:210mm;font-family: Roboto,sans-serif;'>
      <div class='layout wrap'>
          <table>
              <tr>
                <td class='no-boder sub-title m-text'><image src='/static/v-logo.png'/></td>
                <td class='no-boder title m-text'>NGUỒN HÀNG CHINA<br/>PHIẾU XUẤT KHO<p class='no-boder body-text m-text'>Mã phiếu: Y${item.ID}</p></td>
              </tr>	
              <tr>
                <td class='no-boder body-text m-text'><i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i></td>
              </tr>	
              ${contact_info}
            </table>
            <table>
              <tr>
                  <td class='sub-title m-text'>STT</td>            
                  <td class='sub-title m-text'>Mã lô</td>           
                  <td class='sub-title m-text'>Mã vận đơn</td>
                  <td class='sub-title m-text'>Trạng thái</td>
                  <td class='sub-title m-text'>Mã đơn hàng</td>
                  <td class='sub-title m-text'>Số kiện</td>
                  ${payment ? "<td class='sub-title m-text'>Cước nội địa (1)</td>" : ""}
                  <td class='sub-title m-text'>Cân nặng (kg)</td> 
                  <td class='sub-title m-text'>Kích thước (m³)</td> 
                  ${payment ? "<td class='sub-title m-text'>Cân tính tiền</td>" : ""}
                  ${payment ? "<td class='sub-title m-text'>Khối tính tiền</td>" : ""}
                  ${payment ? "<td class='sub-title m-text'>Đơn giá</td>" : ""}
                  ${payment ? "<td class='sub-title m-text'>Cước vận chuyển (2)</td>" : ""}
                  ${payment ? "<td class='sub-title m-text'>Tổng tiền (1+2)</td>" : ""}
                  <td class='sub-title m-text'>Ghi chú</td>
              </tr>
              ${html_packages}
              <tr>
                <td class='sub-title m-text' colspan='5'>Tổng số</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'NumberOfPack'),'',0)}</td>
                ${payment ? "<td class='sub-title r-text'>" + currency(_.sumBy(packages, (p) => {return parseInt(p.FeeShip * p.ExchangeRate);}),'',0) + "</td>" : ""}
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'Weight'),'',2)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'Volume'),'',3)}</td>
                ${payment ? "<td class='sub-title r-text'>" + currency(_.sumBy(packages, (p) => {return p.PriceType != 3 ? (p.PriceType == 1 ? p.Weight : p.WeightByVolume) : 0;}),'',2) + "</td>" : ""}
                ${payment ? "<td class='sub-title r-text'>" + currency(_.sumBy(packages, (p) => {return p.PriceType == 3 ? p.Volume : 0;}),'',3) + "</td>" : ""}
                ${payment ? "<td class='sub-title r-text'></td>" : ""}
                ${payment ? "<td class='sub-title r-text'>" + currency(_.sumBy(packages, (p) => {return p.FeeWeightAvg || p.TotalFeeWeight;}),'',0) + "</td>" : ""}
                ${payment ? "<td class='sub-title r-text'>" + currency(_.sumBy(packages, (p) => {return p.FeeWeightAvg || p.TotalFeeWeight;}) + _.sumBy(packages, (p) => {return parseInt(p.FeeShip * p.ExchangeRate);}),'',0) + "</td>" : ""}
                <td class='sub-title m-text'></td>
              </tr> 
              ${finance}
              ${payment_note}
              <tr>
                  <td class='no-boder body-text' colspan='${payment ? 15 : 9}'><i>Quý khách vui lòng kiểm tra lại mã hàng, số lượng, khối lượng khi nhận hàng!</i></td>
              </tr> 
              <tr>
                  <td class='no-boder body-text' colspan='${payment ? 15 : 9}'>Chứng từ, giấy tờ kèm theo:</td>
              </tr> 
              <tr>
              </tr> 
              <tr>
                  <td class='no-boder sub-title m-text' colspan='${payment ? 5 : 3}'>Người giao<br/><i>(Ký, ghi rõ họ tên)</i></td>
                  <td class='no-boder sub-title m-text' colspan='${payment ? 5 : 3}'>Người nhận<br/><i>(Ký, ghi rõ họ tên)</i></td>
                  <td class='no-boder sub-title m-text' colspan='${payment ? 5 : 3}'>Người lập phiếu<br/><i>(Ký, ghi rõ họ tên)</i></td>
              </tr>
              <tr style='height: 40px'>
                  <td class='no-boder body-text' colspan='${payment ? 15 : 9}'></td>
              </tr> 
              ${qrcode}
              </table>
            </div>
        </body>
  </html>`;
  if(render) {
    return print_content;
  }
  var mywindow = window.open("", "PRINT");
  mywindow.document.write(print_content);
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  // mywindow.close();
  return true;
}

export function print_export_receipt_order(item, packages, render = false, payment = false, bigpackage = false) {
  let html_packages = ''
  packages = _.orderBy(packages, 'BigPackageID');
  packages = _.orderBy(packages, 'Status');
  let last_bigpackage_id = 0;
  let group_idx = 0;
  
  // Tạo map OrderID để lưu lần đầu mỗi order được hiển thị
  let orderFirstDisplay = {};
  
  for (let i = 0; i < packages.length; i++) {
    const p = packages[i];
    if(last_bigpackage_id != p.BigPackageID && bigpackage) {
      group_idx = 0;
    }
    group_idx++;
    const _packages = _.filter(packages, (t) => {return t.BigPackageID == p.BigPackageID});
    
    // Lấy thông tin đơn hàng từ item.Orders
    let orderInfo = item.Orders && item.Orders.length > 0 ? 
      item.Orders.find(o => o.ID === p.OrderID || o.OrderID === p.OrderID) : null;
    
    // Kiểm tra xem đây có phải lần đầu tiên của OrderID không
    let isFirstPackageOfOrder = !orderFirstDisplay[p.OrderID];
    if(isFirstPackageOfOrder) {
      orderFirstDisplay[p.OrderID] = true;
    }
    // Lấy giá trị tiền hàng, đã cọc, còn thiếu từ Order
    let tongTien = (isFirstPackageOfOrder && orderInfo) ? orderInfo.TotalAmountVND : 0;
    let phiKhac = (isFirstPackageOfOrder && orderInfo) ? orderInfo.FeeOther : 0;
    let tienHang = (isFirstPackageOfOrder && orderInfo) ? orderInfo.AmountVND : 0;
    let daCoq = (isFirstPackageOfOrder && orderInfo) ? (orderInfo.Deposit) : 0;
    let conThieu = (isFirstPackageOfOrder && orderInfo) ? (tienHang > daCoq ? tienHang - daCoq : 0) : 0;

    html_packages = html_packages + `<tr>
                        <td class='body-text m-text'>${i+1}</td>
                        ${group_idx == 1 && bigpackage ? "<td class='body-text m-text' rowspan='"+ _packages.length +"'>" + p.PackageCode + "</td>" : "<td class='body-text m-text'>" + p.PackageCode + "</td>" }
                        <td class='body-text m-text'>${p.PackageType == 1 ? 'KG' : 'MD'}${p.OrderID}</td>
                        <td class='body-text'>${p.TransactionCode}</td>
                        <td class='body-text'>${p.ProductName || ''}</td>
                        <td class='body-text'>${p.Status == 5 ? 'Đã xuất kho' : 'Chưa xuất'}</td>
                        <td class='body-text r-text'>${currency(p.NumberOfPack,'',0)}</td>
                        <td class='body-text r-text'>${p.PriceType != 3 ? currency(p.PriceType == 1 ? p.Weight : p.WeightByVolume,'',2) : currency(p.Volume,'',3)}</td>
                        <td class='body-text r-text'>${currency(p.FeeWeight || 0,'',0)}</td>
                        <td class='body-text r-text'>${currency(parseInt(p.FeeShip*p.ExchangeRate) || 0,'',0)}</td>
                        <td class='body-text r-text'>${currency(phiKhac,'',0)}</td>
                        <td class='body-text r-text'>${currency((Math.max(p.FeeWeightAvg, p.TotalFeeWeight)) || 0,'',0)}</td>
                        <td class='body-text r-text'>${currency(tienHang,'',0)}</td>
                        <td class='body-text r-text'>${currency(daCoq,'',0)}</td>
                        <td class='body-text r-text'>${currency(tongTien - daCoq > 0 ? tongTien - daCoq : 0,'',0)}</td>
                      </tr>`;
    if(group_idx == _packages.length && _packages.length < packages.length && bigpackage) {
      html_packages = html_packages + `<tr>
        <td class='sub-title m-text' colspan='7'></td>
        <td class='sub-title r-text'>${currency(_.sumBy(_packages, (p) => {return p.PriceType != 3 ? (p.PriceType == 1 ? p.Weight : p.WeightByVolume) : p.Volume;}),'',2)}</td>
        <td class='sub-title r-text'>${currency(_.sumBy(_packages, (p) => {return p.FeeWeight || 0;}),'',0)}</td>
        <td class='sub-title r-text'>${currency(_.sumBy(_packages, (p) => {return parseInt(p.FeeShip * p.ExchangeRate);}),'',0)}</td>
        <td class='sub-title r-text'>0</td>
        <td class='sub-title r-text'>${currency(_.sumBy(_packages, (p) => {return Math.max(p.FeeWeightAvg, p.TotalFeeWeight) + parseInt(p.FeeShip*p.ExchangeRate);}),'',0)}</td>
        <td class='sub-title r-text'>${currency(_.sumBy(_packages, (p) => {let o = item.Orders ? item.Orders.find(ord => ord.ID === p.OrderID) : null; return o ? (o.TotalAmountVND - (o.FeeWeightAmount || o.TotalFeeWeight)) : 0;}),'',0)}</td>
        <td class='sub-title r-text'>${currency(_.sumBy(_packages, (p) => {let o = item.Orders ? item.Orders.find(ord => ord.ID === p.OrderID) : null; return o ? o.Deposit : 0;}),'',0)}</td>
        <td class='sub-title r-text'>${currency(_.sumBy(_packages, (p) => {let o = item.Orders ? item.Orders.find(ord => ord.ID === p.OrderID) : null; return o ? (o.TotalAmountVND - o.Deposit) : 0;}),'',0)}</td>
      </tr>`
    }
    last_bigpackage_id = p.BigPackageID;
  }

  let contact_info = `<tr><td class='no-boder sub-title'>Người nhận: DL${item.CustomerID} - ${item.CustomerName}</td></tr>
                      <tr><td class='no-boder sub-title'>Điện thoại: ${item.PhoneNumber}</td></tr>
                      <tr><td class='no-boder sub-title'>Địa chỉ: ${item.Address}</td></tr>`
  
  let summary_finance = ''
  let qrcode = ''
  let payment_note = ''
  
  if(payment) {
    contact_info = ``;
        
    let old_debt = item.OldPayLeft !== undefined ? item.OldPayLeft : 0;
    
    // Tính tổng tiền từ Orders + cước vận chuyển từ packages
    let totalFromOrders = item.Orders && item.Orders.length > 0 ? 
      _.sumBy(item.Orders, (o) => {return o.Status != 9 ? (o.TotalAmountVND - o.Deposit) : 0;}) : 0;
    // let totalShippingFee = _.sumBy(packages, (p) => {return Math.max(p.FeeWeightAvg, p.TotalFeeWeight) || 0;});
    let total_money = totalFromOrders; // + totalShippingFee;
    let need_pay = total_money + old_debt > item.Wallet ? total_money + old_debt - item.Wallet : 0;
    
    summary_finance = `<tr>
          <td class='sub-title m-text' colspan='14' style='text-align: right; padding: 8px; font-size: 12px;'><b>TỔNG TIỀN</b></td>
          <td class='sub-title m-text' style='text-align: right; padding: 8px; font-size: 12px;'><b>${currency(total_money)}</b></td>
        </tr>
        <tr>
          <td class='sub-title m-text' colspan='14' style='text-align: right; padding: 8px; font-size: 12px;'><b>NỢ CŨ</b></td>
          <td class='sub-title m-text' style='text-align: right; padding: 8px; font-size: 12px;'><b>${currency(old_debt)}</b></td>
        </tr>
        <tr>
          <td class='sub-title m-text' colspan='14' style='text-align: right; padding: 8px; font-size: 12px;'><b>DƯ VÍ</b></td>
          <td class='sub-title m-text' style='text-align: right; padding: 8px; font-size: 12px;'><b>${currency(item.Wallet)}</b></td>
        </tr>
        <tr>
          <td class='sub-title m-text' colspan='14' style='text-align: right; padding: 8px; font-size: 12px;'><b>SỐ TIỀN CẦN THANH TOÁN</b></td>
          <td class='sub-title m-text' style='text-align: right; padding: 8px; font-size: 12px;'><b>${currency(need_pay)}</b></td>
        </tr>`;
    
    qrcode = `<tr>
                  <td class='no-boder body-text' colspan='15' style='text-align: center; padding: 15px 10px; font-size: 11px;'>Quý khách vui lòng scan mã QR trong các tài khoản dưới đây để thanh toán nhanh nhất.</td>
              </tr>
              <tr>
                <td class='no-boder sub-title m-text' colspan='7' style='text-align: center; padding: 10px;'><image src='https://vietqr.app/img?acc=0972582984&bank=MBBank&amount=${need_pay}&des=DL${item.CustomerID}&holder=BUI+KHANH+LY&template=compact&showinfo=true' style='width: 200px'/></td>
                <td class='no-boder sub-title m-text' colspan='8' style='text-align: center; padding: 10px;'><image src='https://vietqr.app/img?acc=1233568688&bank=ACB&amount=${need_pay}&des=DL${item.CustomerID}&holder=BUI+KHANH+LY&template=compact&showinfo=true' style='width: 200px'/></td>
              </tr>`;
    
    payment_note = `<tr>
                      <td class='no-boder body-text' colspan='15' style='padding: 5px 10px;'><b>Ghi chú:</b></td>
                    </tr>
                    <tr>
                      <td class='no-boder body-text' colspan='15' style='padding: 2px 10px;'><i>Nợ cũ: là tổng tiền đơn hàng (không thuộc phiếu này) đã xuất kho nhưng chưa thanh toán</i></td>
                    </tr>
                    <tr>
                        <td class='no-boder body-text' colspan='15' style='padding: 2px 10px;'><i>Quý khách vui lòng kiểm tra lại mã hàng, số lượng, khối lượng khi nhận hàng</i></td>
                    </tr> `;
  }

  const print_content = `<html>
  <head>
      <title>Phiếu thanh toán</title>
      <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body { font-family: Arial, sans-serif; font-size: 12px; }
          .header-container { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 10px; }
          .header-left { flex: 0 0 150px; }
          .header-center { flex: 1; text-align: center; }
          .header-right { flex: 0 0 300px; border: 1px solid #000; padding: 5px; }
          .header-right table { width: 100%; border-collapse: collapse; }
          .header-right td { padding: 3px 5px; border-bottom: 1px solid #999; font-size: 12px; }
          .header-right td:first-child { font-weight: bold; width: 80px; }
          .title { font-size: 16px; font-weight: bold; margin-bottom: 5px; }
          .sub-title { font-size: 12px; font-weight: bold; }
          .body-text { font-size: 12px; }
          .l-text { text-align: left; }
          .r-text { text-align: right; }
          .m-text { text-align: center; }
          table.main-table { border-collapse: collapse; width: 100%; margin-top: 10px; }
          table.main-table td, table.main-table th { border: 1px solid #999; padding: 3px 4px; font-size: 12px; }
          .no-boder { border: none !important; }
          @media print {
              @page { size: A4 landscape; margin: 8mm; }
              body { margin: 0; }
          }
      </style>
  </head>
  
  <body>
      <div class='header-container'>
          <div class='header-left'>
              <img src='/static/v-logo.png' style='width: 120px;'/>
          </div>
          <div class='header-center'>
              <div class='title'>NGUỒN HÀNG CHINA</div>
              <div class='title' style='font-size: 14px;'>PHIẾU THANH TOÁN</div>
              <div class='body-text' style='font-style: italic; margin-top: 5px;'>Mã phiếu: ${item.ID ? 'Y' + item.ID : ''}</div>
              <div class='body-text' style='font-style: italic;'>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</div>
          </div>
          <div class='header-right'>
              <table>
                  <tr><td>Người nhận:</td><td>DL${item.CustomerID}</td></tr>
                  <tr><td>Điện thoại:</td><td>${item.PhoneNumber}</td></tr>
                  <tr><td>Địa chỉ:</td><td>${item.Address}</td></tr>
              </table>
          </div>
      </div>
      
      <table class='main-table'>
          <tr style='background-color: #FFFF99;'>
              <td class='sub-title m-text' style='width: 25px;' rowspan='2'>STT</td>            
              <td class='sub-title m-text' style='width: 70px;' rowspan='2'>Mã lô</td>           
              <td class='sub-title m-text' style='width: 60px;' rowspan='2'>Mã đơn hàng</td>
              <td class='sub-title m-text' style='width: 80px;' rowspan='2'>Mã vận đơn</td>
              <td class='sub-title m-text' style='width: 60px;' rowspan='2'>Tên hàng</td>
              <td class='sub-title m-text' style='width: 60px;' rowspan='2'>Trạng thái</td>
              <td class='sub-title m-text' style='width: 40px;' rowspan='2'>Số kiện</td>
              <td class='sub-title m-text' colspan='5'>CƯỚC VẬN CHUYỂN</td>
              <td class='sub-title m-text' style='width: 60px;' rowspan='2'>Tiền hàng<br/>(4)</td>
              <td class='sub-title m-text' style='width: 60px;' rowspan='2'>Đã trả<br/>(5)</td>
              <td class='sub-title m-text' style='width: 70px;' rowspan='2'>Thành tiền<br/>(1)+(2)+(3)+(4)-(5)</td>
          </tr>
          <tr style='background-color: #FFFF99;'>
              <td class='sub-title m-text' style='width: 55px;'>Số kg/ khối</td>
              <td class='sub-title m-text' style='width: 50px;'>Đơn giá</td>
              <td class='sub-title m-text' style='width: 70px;'>Cước nội địa TQ<br/>(1)</td>
              <td class='sub-title m-text' style='width: 60px;'>Phí giao hàng<br/>(2)</td>
              <td class='sub-title m-text' style='width: 60px;'>Tiền vận chuyển<br/>(3)</td>
          </tr>
          ${html_packages}
          ${summary_finance}
          ${payment_note}
          ${qrcode}
      </table>
  </body>
  </html>`;
  if(render) {
    return print_content;
  }
  var mywindow = window.open("", "PRINT");
  mywindow.document.write(print_content);
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  // mywindow.close();
  return true;
}

export function print_inventory(item, packages, render = false) {
  let html_packages = ''
  for (let i = 0; i < packages.length; i++) {
    const p = packages[i];
    html_packages = html_packages + `<tr>
                        <td class='body-text m-text'>${i+1}</td>
                        <td class='body-text'>${p.TransactionCode}</td>
                        <td class='body-text m-text'>${p.PackageType == 1 ? 'KG' : 'MD'}${p.OrderID}</td>
                        <td class='body-text r-text'>${currency(p.NumberOfPack,'',0)}</td>
                        <td class='body-text r-text'>${currency(p.Weight,'',2)}</td>
                        <td class='body-text r-text'>${currency(p.Volume, '', 3)}</td>
                        <td class='body-text r-text'>${currency(p.WeightByVolume,'',2)}</td>
                        <td class='body-text r-text'>${ p.PriceType != 3 ? currency(p.PriceType == 1 ? p.Weight : p.WeightByVolume,'',2) : ''}</td>
                        <td class='body-text r-text'>${ p.PriceType == 3 ? currency(p.Volume,'',3) : ''}</td>
                        <td class='body-text m-text'></td>
                      </tr>`
  }
  let contact_info = `
    <tr>
      <td class='no-boder sub-title'>Người nhận: ${item.Username}</td>
      <td class='no-boder sub-title'>Tổng tiền: ${currency(item.TotalAmount)}</td>
    </tr>
    <tr>
      <td class='no-boder sub-title'>Kho nhận: ${item.StoreName}</td>
      <td class='no-boder sub-title'>Đã trả: ${currency(item.Payment)}</td>
    </tr>
    <tr>
      <td class='no-boder sub-title'></td>
      <td class='no-boder sub-title'>Cần trả thêm: ${currency(item.RemainAmount)}</td>
    </tr>
    `;

  const print_content = `<html>
  <head>
      <title>Phiếu kiểm kho</title>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 11px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 11px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 11px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 30px; padding: 5px} @media print { @page { size: auto; margin: 20mm 8mm 8mm 20mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } } .no-boder {border: 0px !important;} .quantity {width: 30px;} .width-volumn {width: 50px;}
      </style>
  </head>
  
  <body style='width:210mm;font-family: Roboto,sans-serif;'>
      <div class='layout wrap'>
          <table>
              <tr>
                <td class='no-boder sub-title m-text'><image src='/static/v-logo.png'/></td>
                <td class='no-boder title m-text'>NGUỒN HÀNG CHINA<br/>PHIẾU KIỂM KHO</td>
              </tr>	
              <tr>
                <td class='no-boder body-text m-text'><i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i></td>
              </tr>	
              ${contact_info}
            </table>
            <table>
              <tr>
                  <td class='sub-title m-text'>STT</td>            
                  <td class='sub-title m-text'>Mã vận đơn</td>            
                  <td class='sub-title m-text'>Mã đơn hàng</td>
                  <td class='sub-title m-text'>Số kiện</td>
                  <td class='sub-title m-text'>Cân nặng (kg)</td> 
                  <td class='sub-title m-text'>Kích thước (m³)</td> 
                  <td class='sub-title m-text'>Cân quy đổi</td>
                  <td class='sub-title m-text'>Cân tính tiền</td>
                  <td class='sub-title m-text'>Khối tính tiền</td>
                  <td class='sub-title m-text'>Ghi chú</td>
              </tr>
              ${html_packages}
              <tr>
                <td class='sub-title m-text' colspan='3'>Tổng số</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'NumberOfPack'),'',0)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'Weight'),'',2)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'Volume'),'',3)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, 'WeightByVolume'),'',2)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, (p) => {return p.PriceType != 3 ? (p.PriceType == 1 ? p.Weight : p.WeightByVolume) : 0;}),'',2)}</td>
                <td class='sub-title r-text'>${currency(_.sumBy(packages, (p) => {return p.PriceType == 3 ? p.Volume : 0;}),'',3)}</td>
                <td class='sub-title m-text'></td>
              </tr> 
              </table>
            </div>
        </body>
  </html>`;
  var doc = document.getElementById('print_frame').contentWindow.document;
  doc.open();
  doc.write(print_content);
  doc.close();
  setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
}

export function print_quote(item, itemDetail) {
  let html_packages = ''
  let contact_info = `
    <tr>
      <td class='no-boder sub-title'>Khách hàng: ${item.FullName}</td>
      <td class='no-boder sub-title'>Điện thoại: ${item.PhoneNumber}</td>
      <td colspan="2" class='no-boder sub-title'></td>
    </tr>
    <tr>
      <td class='no-boder sub-title'>Kho gửi: ${item.ChinaStoreID}</td>
      <td class='no-boder sub-title'>Kho nhận: ${item.ReceivePlaceID}</td>
      <td colspan="2" class='no-boder sub-title'></td>
    </tr>
    <tr>
      <td class='no-boder sub-title'>Số lượng: ${currency(item.Qty)}</td>
      <td class='no-boder sub-title'>Màu sắc: ${currency(item.Color)}</td>
      <td class='no-boder sub-title'>Kích cỡ: ${currency(item.Size)}</td>
      <td class='no-boder sub-title'>Chất liệu: ${currency(item.Material)}</td>
    </tr>
    `;

  const print_content = `<html>
  <head>
      <title>Phiếu báo giá</title>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 11px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 11px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 11px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 30px; padding: 5px} @media print { @page { size: auto; margin: 20mm 8mm 8mm 20mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } } .no-boder {border: 0px !important;} .quantity {width: 30px;} .width-volumn {width: 50px;}
      </style>
  </head>
  
  <body style='width:210mm;font-family: Roboto,sans-serif;'>
      <div class='layout wrap'>
            <table>
              <tr>
                <td colspan="2" class='no-boder sub-title m-text'><image src='/static/v-logo.png'/></td>
                <td colspan="2" class='no-boder title m-text'>NGUỒN HÀNG CHINA<br/>BÁO GIÁ</td>
              </tr>	
              <tr>
                <td colspan="4" class='no-boder body-text m-text'><i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i></td>
              </tr>	
              ${contact_info}
            </table>
            <table>
              <tr>
                <td class='no-boder sub-title'>Giá sản phẩm (¥): ${currency(itemDetail.Price, '', 2)}</td>
                <td colspan="3" class='no-boder sub-title'></td>
              </tr>
              <tr>
                <td class='no-boder sub-title'>Cước vận chuyển nội địa (¥): ${currency(itemDetail.FeeShip, '', 2)}</td>
                <td colspan="3" class='no-boder sub-title'></td>
              </tr>
              <tr>
                <td class='no-boder sub-title'>Tỷ giá: ${currency(item.ExchangeRate)}</td>
                <td colspan="3" class='no-boder sub-title'></td>
              </tr>
              <tr>
                <td class='no-boder sub-title'>Phí mua hộ: ${currency(itemDetail.OrderFee)}</td>
                <td colspan="3" class='no-boder sub-title'></td>
              </tr>
              <tr>
                <td class='no-boder sub-title'>Số lượng/thùng: ${currency(itemDetail.Qty)}</td>
                <td colspan="3" class='no-boder sub-title'></td>
              </tr>
              <tr>
                <td class='no-boder sub-title'>Cân nặng mỗi thùng: ${currency(itemDetail.WeightOfPack, '', 2)}</td>
                <td colspan="3" class='no-boder sub-title'></td>
              </tr>
              <tr>
                <td class='no-boder sub-title'>Số thùng: ${currency(itemDetail.NumberOfPack, '', 2)}</td>
                <td colspan="3" class='no-boder sub-title'></td>
              </tr>
              <tr>
                <td class='no-boder sub-title'>Chiều dài mỗi thùng: ${currency(itemDetail.LengthOfPack)} cm</td>
                <td class='no-boder sub-title'>Chiều rộng mỗi thùng: ${currency(itemDetail.WidthOfPack)} cm</td>
                <td class='no-boder sub-title'>Chiều cao mỗi thùng: ${currency(itemDetail.HeightOfPack)} cm</td>
                <td class='no-boder sub-title'></td>
              </tr>
              <tr>
                <td class='no-boder sub-title'>Phí vận chuyển mỗi thùng: ${currency(itemDetail.WeightFee/itemDetail.NumberOfPack)}</td>
                <td colspan="3" class='no-boder sub-title'></td>
              </tr>
              <tr>
                <td class='no-boder sub-title'>Tổng phí vận chuyển: ${currency(itemDetail.WeightFee)}</td>
                <td colspan="3" class='no-boder sub-title'></td>
              </tr>
              <tr>
                <td class='no-boder sub-title'>Giá full/sản phẩm: ${currency(itemDetail.CostOfProduct)}</td>
                <td colspan="3" class='no-boder sub-title'></td>
              </tr>
              <tr>
                <td class='no-boder sub-title'>Tổng tiền: ${currency(itemDetail.TotalAmount)}</td>
                <td colspan="3" class='no-boder sub-title'></td>
              </tr>
            </table>
            </div>
        </body>
  </html>`;
  var doc = document.getElementById('print_frame').contentWindow.document;
  doc.open();
  doc.write(print_content);
  doc.close();
  setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
}

export function print_export_bigpackage(export_id, partner_name, total_pack, total_small_pack, total_weight, total_volume, bigpackages) {
  let html_bigpackages = '';
  for (let i = 0; i < bigpackages.length; i++) {
    const bp = bigpackages[i];
    html_bigpackages += `<tr>
                            <td class='body-text m-text'>${i + 1}</td>
                            <td class='body-text'>${bp.PackageCode}</td>
                            <td class='body-text r-text'>${currency(bp.NumberOfPack, '', 0)}</td>
                            <td class='body-text r-text'>${currency(bp.TotalSmallPack, '', 0)}</td>
                            <td class='body-text r-text'>${currency(bp.Weight, '', 2)}</td>
                            <td class='body-text r-text'>${currency(bp.Volume, '', 3)}</td>
                          </tr>`;
  }

  const print_content = `<html>
  <head>
      <title>Phiếu Xuất Lô Hàng</title>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 11px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 11px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 11px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 30px; padding: 5px} @media print { @page { size: auto; margin: 20mm 8mm 8mm 20mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } } .no-boder {border: 0px !important;} .quantity {width: 30px;} .width-volumn {width: 50px;}
      </style>
  </head>
  
  <body style='width:210mm;font-family: Roboto,sans-serif;'>
      <div class='layout wrap'>
          <table>
              <tr>
                  <td class='no-boder sub-title m-text'><image src='/static/v-logo.png'/></td>
                  <td class='no-boder title m-text'>NGUỒN HÀNG CHINA<br/>PHIẾU XUẤT LÔ HÀNG</td>
              </tr>
              <tr>
                  <td class='no-boder body-text m-text'><i>Ngày(天) ${moment().date()} tháng(月) ${moment().month() + 1} năm(年) ${moment().year()}</i></td>
              </tr>
              <tr>
                  <td class='no-boder sub-title'>Mã phiếu xuất(交货单): ${export_id}</td>
              </tr>
              <tr>
                  <td class='no-boder sub-title'>Đối tác vận chuyển(伙伴): ${partner_name}</td>
              </tr>
              <tr>
                  <td class='no-boder sub-title'>Tổng số kiện(全部的): ${currency(total_pack, '', 0)}</td>
              </tr>
              <tr>
                  <td class='no-boder sub-title'>Tổng số mã(总代码): ${currency(total_small_pack, '', 0)}</td>
              </tr>
              <tr>
                  <td class='no-boder sub-title'>Tổng khối lượng(总重量): ${currency(total_weight, '', 2)} kg</td>
              </tr>
              <tr>
                  <td class='no-boder sub-title'>Tổng thể tích(总体积): ${currency(total_volume, '', 3)} m³</td>
              </tr>
          </table>
          <table>
              <tr>
                  <td class='sub-title m-text'>STT(命令)</td>
                  <td class='sub-title m-text'>Mã Lô(批号)</td>
                  <td class='sub-title m-text'>Số Mã(代码数量)</td>
                  <td class='sub-title m-text'>Số Kiện(包裹数量)</td>
                  <td class='sub-title m-text'>Số Kg(重量)</td>
                  <td class='sub-title m-text'>Số m³(体积)</td>
              </tr>
              ${html_bigpackages}
              <tr>
                  <td class='sub-title m-text' colspan='3'>Tổng cộng(全部的)</td>
                  <td class='sub-title r-text'>${currency(total_pack, '', 0)}</td>
                  <td class='sub-title r-text'>${currency(total_weight, '', 2)}</td>
                  <td class='sub-title r-text'>${currency(total_volume, '', 3)}</td>
              </tr>
              <tr>
                  <td class='no-boder body-text' colspan='6'></td>
              </tr>
              <tr>
                  <td class='no-boder sub-title m-text' colspan='3'>Người giao(送货员)<br/><i>(Ký, ghi rõ họ tên)</i><br/><i>(签名并打印全名)</i></td>
                  <td class='no-boder sub-title m-text' colspan='3'>Người nhận(接收者)<br/><i>(Ký, ghi rõ họ tên)</i><br/><i>(签名并打印全名)</i></td>
              </tr>
              <tr style='height: 40px'>
                  <td class='no-boder body-text' colspan='6'></td>
              </tr>
          </table>
      </div>
  </body>
  </html>`;
  return print_content;
}